export default __webpack_public_path__ + "static/logo-1b1131548ea4677859b95a59c4b8d12a.svg";